export const initialWebsiteBannerFile = {
  id: 0,
  websiteBannerId: 0,
  previewPath: '',
  originPath: '',
  fName: '',
  fExtension: '',
  fDimensions: '',
  fSize: 0,
  isVisible: false,
}
